import { config } from "JS/Config";
import { User, UserTeamInfo } from "JS/Models";
import { BaseService } from "../BaseService";
import { appConstants } from "JS/Helpers/Constants";
import { AxiosResponse } from "axios";

export class HomeService extends BaseService {
    async getTeamsStatusForUser(
        sendCall: boolean,
        defaultTeamInfo: UserTeamInfo,
    ) {
        if (sendCall || !defaultTeamInfo?.teamName)
            return await this.ngCall<UserTeamInfo>(
                "get",
                appConstants.ngEndpoints.getTeamInfo(config?.user?.memberId),
            );
        else
            return new Promise<AxiosResponse<UserTeamInfo>>((res) => {
                res({
                    data: defaultTeamInfo,
                    status: 200,
                    statusText: "OK",
                    headers: {},
                    config: { headers: {} as any },
                });
            });
    }

    async getLandingPageJson(filePath: string): Promise<string> {
        const response = await this.ngCall<any>(
            "get",
            appConstants.ngEndpoints.s3File,
            {
                params: {
                    bucketName: config.s3.landingPage.bucketName,
                    filePath,
                },
            },
        );
        return JSON.stringify(response.data);
    }

    getExternalSso = (accessToken: string, memberId: string) =>
        this.ngCall<Omit<User, "memberId">>(
            "post",
            appConstants.ngEndpoints.sso,
            {
                accessToken,
                memberId,
                clientId: 2,
                scope: "media_scope",
                platform: "web",
            },
        );
}
